import * as ApiWithToken from "../callApiWithToken";

const ImageService = {
  getBlobImage: async function (url: string) {
    return ApiWithToken.postApiBlob(
      process.env.REACT_APP_GENERAL_API + `Images/getCompressedBlobImage`,
      { url }
    );
  },
  getBlobPdf: async function (url: string) {
    return ApiWithToken.postApiBlob(
      process.env.REACT_APP_GENERAL_API + `Images/getCompressedBlobPDF`,
      { url }
    );
  },
  getFilePath: async function (url: string) {
    return ApiWithToken.postApi(
      process.env.REACT_APP_GENERAL_API + `Products/GetFile`,
      { url }
    );
  },
};

export default ImageService;
